import { create } from 'zustand';

const useTwilioLockStore = create((set, get) => ({
	syncDoc: null,
	isLocked: false,
	lockHolder: null,
	lockHolderId: null,
	documentId: null,
	isInitialized: false,
	setSyncDoc: doc => set({ syncDoc: doc }),
	getSyncDoc: () => get().syncDoc,
	setIsInitialized: isInitialized => set({ isInitialized }),
	updateLockState: () => {
		const { syncDoc } = get();
		if (!syncDoc) return;
		const { data } = syncDoc;
		set({
			isLocked: data.isLocked || false,
			lockHolder: data.lockHolder || null,
			lockHolderId: data.lockHolderId || null,
			documentId: data.documentId || null,
		});
	},
	reset: () =>
		set({
			syncDoc: null,
			isLocked: false,
			lockHolder: null,
			lockHolderId: null,
			documentId: null,
			isInitialized: false,
		}),
}));

export default useTwilioLockStore;
